import React from 'react'
import SubscriptionDashboard from './SubscriptionDashboard'
// import SubscriptionDashboard from '../company/test/SubscriptionDashboard'

const SubscriptionMain = () => {
  return (
    <>
    <SubscriptionDashboard />
    </>
  )
}

export default SubscriptionMain